/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import store from '../../../store';
import moment from 'moment';

/**
* Checks if socket related updates on inbox items should render in the UI
*
* @param {Object} conversation The inbox conversation to check.
* @param {boolean} ignoreSearch The inbox conversation to check.
* @returns {boolean}
*/

const satisfiesInboxFilters = (conversation, includeSearch = false) => {
  const appliedFilters = store.getState().livechat.inboxFilters;
  const me = store.getState().auth.currentUser;

  if (includeSearch && appliedFilters.searchText) {
    return false;
  }

  let isValidDate = true;
  let hasValidBots = true;
  let hasValidUsers = true;

  // Date filters
  if (appliedFilters.customDate.length) {
    isValidDate = moment(conversation.startDate).isAfter(appliedFilters.customDate[0]) && moment(conversation.startDate).isBefore(appliedFilters.customDate[1]);
  } else if (appliedFilters.date) {
    isValidDate = moment(conversation.startDate).isAfter(appliedFilters.date);
  }

  // Bots filters
  if (appliedFilters.bots.length) {
    hasValidBots = appliedFilters.bots.includes(conversation.tenantId);

  }

  // Users filters
  if (appliedFilters.users.length) {
    hasValidUsers = appliedFilters.users.some(user => conversation.livechatParticipants.find(participant => participant.platformUserId === user));
  }

  if (
    hasValidBots && hasValidUsers && isValidDate
    && appliedFilters.status.includes(conversation.status)
    && (appliedFilters.transferredOnly ? conversation.livechatParticipants.find(participant => participant.platformUserId === me.id && participant.status === 'transferred') : true)
    && (appliedFilters.unreadOnly ? conversation.livechatParticipants.find(participant => participant.platformUserId === me.id && !participant.lastMessageRead) : true)
  ) {
    return true;
  }

  return false;
};

export default satisfiesInboxFilters;
